import { useMemo } from 'react';

import { useGetWizardDelegatedTasks } from 'lib/hooks/queries/wizard/useGetWizardDelegatedTasks';

export const useAssignedTasks = ({ instanceId, practiceId, currentUserId }) => {
  const { data: taskDelegationData } = useGetWizardDelegatedTasks({
    params: {
      wizard_instance_id: instanceId,
      get_all_delegations: true,
      practiceId,
      limit: 100
    },
    options: { enabled: Boolean(instanceId) }
  });

  const steps = taskDelegationData?.data?.delegations?.steps;
  const substeps = taskDelegationData?.data?.delegations?.substeps;

  const assignedTasks = useMemo(
    () => [
      ...(steps ?? [])
        .filter(
          (step) =>
            Array.isArray(step.assignments) &&
            step.assignments.some((assignment) => assignment.user_id === currentUserId)
        )
        .map((step) => ({
          ...step,
          assignments: step.assignments.filter((assignment) => assignment.user_id === currentUserId)
        })),
      ...(substeps ?? [])
        .filter(
          (substep) =>
            Array.isArray(substep.assignments) &&
            substep.assignments.some((assignment) => assignment.user_id === currentUserId)
        )
        .map((substep) => ({
          ...substep,
          assignments: substep.assignments.filter(
            (assignment) => assignment.user_id === currentUserId
          )
        }))
    ],
    [steps, substeps, currentUserId]
  );

  return {
    assignedTasks,
    delegations: taskDelegationData?.data?.delegations
  };
};
